<template>
  <fb-form-body>
    <el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="fb-form">

      <el-form-item :label="$t('lang.配件编号') + '：'" prop="number">
        <el-input v-model="formData.number"></el-input>
      </el-form-item>

      <el-form-item :label="$t('lang.配件名称') + '：'" required>
        <nation-input v-model="formData.accessoryLang" />
      </el-form-item>

      <el-form-item :label="$t('lang.默认配件图片') + '：'" prop="photo">
        <pic-upload :action="api.upload"
                    :limit="1"
                    :downloadUrl="api.downloadImg"
                    v-model="formData.photo"
                    :data="{category: 'ACCESSORY'}"/>

      </el-form-item>

      <el-form-item :label="$t('lang.五金配件图') + '：'" prop="wjPhoto">
        <pic-upload :action="api.upload"
                    :limit="1"
                    :downloadUrl="api.downloadImg"
                    v-model="formData.wjPhoto"
                    :data="{category: 'ACCESSORY'}"/>
      </el-form-item>

      <el-form-item :label="$t('lang.塑料配件图') + '：'" prop="slPhoto">
        <pic-upload :action="api.upload"
                    :limit="1"
                    :downloadUrl="api.downloadImg"
                    v-model="formData.slPhoto"
                    :data="{category: 'ACCESSORY'}"/>
      </el-form-item>

      <el-form-item :label="$t('lang.线条配件图') + '：'" prop="xtPhoto">
        <pic-upload :action="api.upload"
                    :limit="1"
                    :downloadUrl="api.downloadImg"
                    v-model="formData.xtPhoto"
                    :data="{category: 'ACCESSORY'}"/>
      </el-form-item>

      <el-form-item :label="$t('lang.主语言') + '：'" prop="lang">
        <el-radio-group v-model="formData.lang" style="min-width: 800px">
          <el-row :gutter="24"  >
            <el-col :span="6" v-for="lang in langList" :key="lang.value + '_key'">
              <el-radio :label="lang.value">{{ lang.name }}（{{ lang.value }}）</el-radio>
            </el-col>
          </el-row>
        </el-radio-group>

      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit('form')">{{ $t('lang.确定') }}</el-button>
        <el-button @click="handleReset('form')">{{ $t('lang.重置') }}</el-button>
      </el-form-item>
    </el-form>
  </fb-form-body>
</template>

<script>
import NationInput from "../../components/nation/NationInput";
import PicUpload from "../../components/pic-upload/PicUpload.vue";

export default {
  name: "FittingAdd",
  components: {PicUpload, NationInput},
  data() {
    return {
      api: {
        add: this.$api.accessory.add,
        upload: this.$api.file.upload,
        downloadImg: this.$api.file.downloadImg,
      },
      formErrorMsg: {account: ''},
      formData: {
        photo: '',
        lang: '',
        number: '',
        accessoryLang: {},
        wjPhoto: "",
        slPhoto: "",
        xtPhoto: "",
      },
      langRadio: '',
      isSet: true,
    }

  },
  computed: {
    rules() {

      let checkName = (rule, value, callback) => {
        let data = this.formData['accessoryLang'];
        let key = '';
        for (const dataKey in data) {
          if (data[dataKey] == '') {
            key = dataKey;
            break;
          }
        }

        if (key) {
          return callback(new Error(this.$t(`lang.${key}不能为空`)));
        }
        return callback();
      };
      let checkPhoto = (rule, value, callback) => {
        if (!this.formData['photo']) {
          return callback(new Error(this.$t('lang.配件图片不能为空')));
        }
        return callback();
      };
      return {
        number: [
          {required: true, message: this.$t('lang.配件编号不能为空'), trigger: 'blur'},
        ],
        name: [
          {required: true, validator: checkName, trigger: 'blur'}
        ],
        photo: [
          {required: true, validator: checkPhoto, trigger: 'blur'}
        ],
        lang: [
          {required: true, message: this.$t('lang.主语言不能为空'), trigger: 'blur'}
        ],
      }
    },
    langList() {
      const vm = this;
      let list = vm.handleFilterLang();

      if(vm.isSet && list.length) {
        list.forEach(i => {
          vm.$set( this.formData['accessoryLang'], i.value, '');
        });
        vm.isSet = false;
      }
      return list;
    }
  },
  methods: {
    handleFilterLang() {
      let sysLang = this.$store.state.sysSetLang;
      let supportLangList = this.$store.state.supportLangList;
      if(sysLang.length) {
        let langList = []
        sysLang.forEach(l => {
          let item = supportLangList.find(s => s.value == l);
          langList.push(item);
        })
        return langList;
      }
      return supportLangList;
    },
    handleUploadRemove(e) {
      if(e.status == "success") this.formData['photo'] = '';
    },
    handleBeforeUpload(file) {
      if(file.type.split('/')[0] != 'image') {
        this.$message.error(this.$t('lang.请上传图片格式文件'))
        return false;
      }
      return true;
    },
    handleUploadSuccess(res) {
      if(res) {
         if (res.status != 200) {
         this.$message.error(res.desc);
       }
       this.formData['photo'] = res.data.fileCode;
       this.$refs.form.clearValidate('photo');
      }
    },
    handleSubmit(form) {
      let vm = this;
      vm.$refs[form].validate((valid) => {
        if (valid) {
          let data = {...vm.formData};
          let langList = data['accessoryLang'];
          data['accessoryLang'] = {};
          for (const key in langList) {
            // 校验主语言
            if(!langList[data['lang']]) {
              vm.$message.error(vm.$t('lang.主语言配件名称不能为空'));
              return;
            }

            // 过滤
            if(langList[key]) {
              data['accessoryLang'][key] = langList[key];
            }
          }
          console.log(vm.formData);

          // return;
           vm.$http.post(vm.api.add, data).then((resp) => {
             if (resp.data.status === 200) {
               vm.$message({
                 type: 'success',
                 message: resp.data.desc
               });
               vm.$router.back();
             }  else {
               vm.$message({
                 type: "error",
                 message: resp.data.desc
               })
             }

           });
        }
      });

    },
    handleReset(form) {
      this.$refs[form].resetFields();
      console.log('form', this.formData)
    }
  }
  ,
  created() {
    // let vm = this;

  }
}
</script>

<style scoped>

.fb-form {
  max-width: 500px;
}

.lang-radio {
  //margin-bottom: 24px;
}

.lang-box {
  display: flex;
  margin-top: 14px;
}

/deep/ .el-radio {
  line-height: 40px;
}


</style>
